var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15091_15588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 38.7C28.0667 34.9667 31.0833 31.575 33.05 28.525C35.0167 25.475 36 22.7667 36 20.4C36 16.7667 34.8417 13.7917 32.525 11.475C30.2083 9.15833 27.3667 8 24 8C20.6333 8 17.7917 9.15833 15.475 11.475C13.1583 13.7917 12 16.7667 12 20.4C12 22.7667 12.9833 25.475 14.95 28.525C16.9167 31.575 19.9333 34.9667 24 38.7ZM24 44C18.6333 39.4333 14.625 35.1917 11.975 31.275C9.325 27.3583 8 23.7333 8 20.4C8 15.4 9.60833 11.4167 12.825 8.45C16.0417 5.48333 19.7667 4 24 4C28.2333 4 31.9583 5.48333 35.175 8.45C38.3917 11.4167 40 15.4 40 20.4C40 23.7333 38.675 27.3583 36.025 31.275C33.375 35.1917 29.3667 39.4333 24 44Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1111 27.6825V21.5175L17.7778 18.39V24.555L23.1111 27.6825ZM24.8889 27.6825L30.2222 24.555V18.39L24.8889 21.5175V27.6825ZM23.1111 29.7525L16.8889 26.13C16.6074 25.965 16.3889 25.7475 16.2333 25.4775C16.0778 25.2075 16 24.9075 16 24.5775V17.4225C16 17.0925 16.0778 16.7925 16.2333 16.5225C16.3889 16.2525 16.6074 16.035 16.8889 15.87L23.1111 12.2475C23.3926 12.0825 23.6889 12 24 12C24.3111 12 24.6074 12.0825 24.8889 12.2475L31.1111 15.87C31.3926 16.035 31.6111 16.2525 31.7667 16.5225C31.9222 16.7925 32 17.0925 32 17.4225V24.5775C32 24.9075 31.9222 25.2075 31.7667 25.4775C31.6111 25.7475 31.3926 25.965 31.1111 26.13L24.8889 29.7525C24.6074 29.9175 24.3111 30 24 30C23.6889 30 23.3926 29.9175 23.1111 29.7525ZM27.5556 17.8725L29.2667 16.8825L24 13.8L22.2667 14.8125L27.5556 17.8725ZM24 19.965L25.7333 18.9525L20.4667 15.87L18.7333 16.8825L24 19.965Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15091_15588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPointIcon);
export default __webpack_public_path__ + "static/media/DropPointIcon.3ac4d0a6d9d321785f9250af7a41470f.svg";
export { ForwardRef as ReactComponent };